module.exports = __webpack_public_path__ + "static/media/tiktok.bb4ff41b.jpg";